export type DocumentDescriptionType =
  | "Contrato com a Tupi"
  | "Contrato com a WeMob"
  | "Nota fiscal de licença de software"
  | "Outro";

export interface DocumentItem {
  id: string;
  name: string;
  size: number;
  file: File;
  description: DocumentDescriptionType | null;
  url?: string;
}

export interface FinancialData {
  bank: string;
  agency: string;
  account: string;
  pixKey: string;
  emails: string[];
}

export const CUSTOMER_TYPE = {
  CONDO: "Condomínio",
  CPO: "CPO",
} as const;

export type CustomerType = (typeof CUSTOMER_TYPE)[keyof typeof CUSTOMER_TYPE];

export interface CompanyFormData {
  companyName: string;
  document: string;
  customerType: CustomerType | null;
  onboardingDocuments: DocumentItem[];
  financial: FinancialData;
}

export const EMPTY_COMPANY: CompanyFormData = {
  companyName: "",
  document: "",
  customerType: null,
  onboardingDocuments: [],
  financial: {
    bank: "",
    agency: "",
    account: "",
    pixKey: "",
    emails: [""],
  },
};

export const BANKS = [
  "001 - Banco do Brasil",
  "033 - Santander",
  "104 - Caixa Econômica Federal",
  "237 - Bradesco",
  "260 - Nu Pagamentos (Nubank)",
  "341 - Itaú Unibanco",
  "380 - Banco PicPay",
  "748 - Sicredi",
];
